import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type ScormPerformanceFragment = { entityId: string, id: string, status: Types.PerformanceStatusEnum, progress: number, estimatedTimeSpent?: number | null, type: Types.PerformanceTypeEnum, entityType: Types.PerformanceEntityTypeEnum, isAvailable: boolean, meta?: string | null, enrolmentInfo?: { dueDate?: string | null } | null };


export type ScormPerformanceFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const ScormPerformanceFragmentDoc = /*#__PURE__*/ gql`
    fragment ScormPerformance on ScormPerformanceType {
  entityId
  id
  status
  progress
  estimatedTimeSpent
  type
  entityType
  isAvailable
  progress
  meta
  enrolmentInfo {
    dueDate
  }
}
    `;